import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormImage" }
const _hoisted_2 = { class: "FormImage__image" }
const _hoisted_3 = ["src"]

import { PropType } from "vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormImage',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.value[__props.item.key],
        alt: "Afbeelding"
      }, null, 8, _hoisted_3)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Kleur",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value[__props.item.key]) = $event))
    }, null, 512), [
      [_vModelText, __props.value[__props.item.key]]
    ])
  ]))
}
}

})